import { Edit, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";

const transform = ({ year, category, amount }) => ({ year, category, amount });

const EditDoctoralSchoolFee = () => (
  <Edit
    title="Редакция на такса за докторантско училище"
    mutationMode="pessimistic"
    actions={<BackButtonToolbar />}
    transform={transform}
  >
    <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
      <SaveForm />
    </SimpleForm>
  </Edit>
);

export default EditDoctoralSchoolFee;
